var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4038 0.658964C14.9182 0.187772 15.6154 -0.0552698 16.3085 0.0106481C23.9862 0.676908 30 7.25149 30 14.9783C30 19.2489 28.1752 23.3325 24.994 26.1815C22.2363 28.6515 18.6547 30 14.9641 30C14.4008 30 13.8345 29.968 13.2692 29.9049C6.50232 29.1437 0.973019 23.6846 0.122067 16.9241C-0.466312 12.2443 1.09082 7.66165 4.39392 4.3544C4.94018 3.80716 5.82519 3.80716 6.37146 4.3544C6.91687 4.90152 6.91687 5.78787 6.37048 6.33511C3.68371 9.02713 2.41723 12.7586 2.8977 16.575C3.58886 22.067 8.08142 26.5017 13.5818 27.121C17.1155 27.5221 20.5065 26.4436 23.1302 24.0938C25.7181 21.7759 27.2034 18.4536 27.2034 14.9783C27.2034 8.80301 22.484 3.53299 16.3984 2.83377V6.93435C16.3984 7.70767 15.7722 8.33487 15.0001 8.33487C14.228 8.33487 13.6018 7.70767 13.6018 6.93435V2.4866C13.6018 1.79434 13.8944 1.12808 14.4038 0.658964ZM16.6245 16.9051C15.1932 18.1785 13.3025 17.8864 12.3187 16.1837L7.79821 8.36184C7.68628 8.16775 7.90307 7.95169 8.09582 8.06375L15.9034 12.5915C17.6063 13.5788 17.8979 15.4685 16.6245 16.9051Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.2ed43217.svg";
export { ForwardRef as ReactComponent };